module.exports = __webpack_public_path__ + "img/loader-green.b3dd4068.gif";